import styles from "../../style.module.scss";
import useStore from "../../store/store";
import formatPrice from "../../utils/format-price";
import {useEffect, useState} from "react";

function Step2({number, rates, promoFinishDate, promoPriceGrid, priceGrid, links}) {
    const [open, setOpen] = useState(true);
    const startDate = useStore((state) => state.startDate)
    const currentRate = useStore((state) => state.currentRate)
    const setCurrentRate = useStore((state) => state.setCurrentRate)
    const ratesHide = useStore((state) => state.ratesHide)
    const setRatesHide = useStore((state) => state.setRatesHide)

    const getListPrices = (rateId) => {
        /*2025-04-30 format*/
        if ((rateId === 1 || rateId === 2) && !!promoFinishDate && !!promoPriceGrid) {
            const date = new Date(promoFinishDate);
            if (date >= startDate) {
                return promoPriceGrid;
            }
        }
        if (priceGrid[rateId]) {
            return priceGrid[rateId];
        }

        return [];
    }
    const canShowRate = (rateId) => {
        let match = false;
        if (!!startDate) {
            const rate = rates?.filter((rate) => rate.id === rateId)?.[0];
            if (rate) {
                const periods = rate?.periods;
                if (periods) {
                    for (let i = 0; i < periods.length; i++) {
                        const [start, finish] = periods[i].split('-');
                        const startPeriod = new Date(parseInt(start) * 1000);
                        const finishPeriod = new Date(parseInt(finish) * 1000);
                        if (startDate >= startPeriod && startDate <= finishPeriod) {
                            match = true;
                        }
                    }
                }
            }
        }

        return match;
    }
    const getActiveRates = () => {
        return rates?.filter((rate) => canShowRate(rate.id))
    }

    const getCurrentValue = () => {
        const rate = rates?.filter((rate) => rate.id === currentRate)?.[0];

        return rate?.name || '';
    }

    useEffect(() => {
        const activeRates = getActiveRates();
        if (!!activeRates.length) {
            if (activeRates.length === 1) {
                //setRatesHide(true)
                const activeRateId = activeRates[0].id;
                if (currentRate !== activeRateId) {
                    setCurrentRate(activeRateId);
                }
            } else {
                //setRatesHide(false)
                if (!currentRate) {
                    const activeRateId = activeRates[0].id;
                    setCurrentRate(activeRateId);
                } else {
                    //may be
                }
            }
        } else {
            //setRatesHide(true)
        }
    }, [rates, startDate, setRatesHide, ratesHide, currentRate, setCurrentRate]);

    if (rates?.length && !ratesHide) {
        return (<div className={styles.newOrder__step}>
                <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
                    <div className={styles.newOrder__stepNumber}>
                        {number}
                    </div>
                    Выберите тариф
                    <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
                    <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
                </div>
                {
                    !!open && (
                        <div className={`${styles.newOrder__stepContent}`}>
                            {
                                rates.map((rate) => {
                                    if (!canShowRate(rate.id)) {
                                        return null;
                                    }
                                    return (<div key={rate.id} className={styles.rate}>
                                        <div className={`${styles.name} p-size`} onClick={() => setCurrentRate(rate.id)}>
                                            <div
                                                className={`${styles.checkbox} ${currentRate === rate.id && styles.checked}`}/>
                                            {rate.name}
                                        </div>
                                        <div className={styles.prices}>
                                            {
                                                !!getListPrices(rate.id)?.length && getListPrices(rate.id)?.map((item, index) => {
                                                    return (
                                                        <div key={index} className={styles.price}>
                                                            {
                                                                (item.days_max === '999') && (
                                                                    <div>суток: от {item.days_min}</div>)
                                                            }
                                                            {
                                                                (
                                                                    item.days_max !== '999') && (
                                                                    <div>{`суток: ${item.days_min === '0' ? '1' : item.days_min} - ${item.days_max}`}</div>
                                                                )
                                                            }

                                                            <div>{formatPrice(item.price)}</div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>);
                                })
                            }
                            {
                                !!links?.rates?.link && (
                                    <a href={links.rates.link} className={styles.moreButton} target='_blank'>Смотреть подробнее</a>)
                            }
                        </div>
                    )
                }

            </div>
        );
    }
    return null;
}

export default Step2;